import { Box, Button, LinearProgress, Typography } from "@mui/material";
import ArrowLeftOutlined from "@mui/icons-material/ArrowLeftOutlined";
import ArrowRightOutlined from "@mui/icons-material/ArrowRightOutlined";
import ListAlt from "@mui/icons-material/ListAlt";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";

export default function NavigationBar({
  handleNext,
  handlePrev,
  currentGroup,
  questionGroup,
  currentPartIndex,
  parts,
  currentGroupIndex,
  isWaiting,
  handleOpenQuestionList,
  showInstructions,
  disablePrev,
  disableNext,
}) {
  const prevDisabled =
    disablePrev !== undefined
      ? disablePrev
      : (!currentGroupIndex && currentPartIndex === 4) || isWaiting;
  const nextDisabled =
    disableNext !== undefined
      ? disableNext
      : (currentGroupIndex === questionGroup.length - 1 &&
          currentPartIndex === parts.length - 1) ||
        isWaiting;
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        p: 1,
        borderTop: 1,
        borderColor: "divider",
      }}
    >
      {/* Previous Button */}
      <Button
        startIcon={<ArrowLeftOutlined />}
        onClick={handlePrev}
        disabled={prevDisabled}
        sx={{ px: 2 }}
      >
        Previous
      </Button>

      {/* Progress indicator */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {showInstructions ? (
          <></>
        ) : (
          <>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              Question {currentGroup?.questions?.[0]?.number}{" "}
              {currentGroup?.questions?.length > 1 &&
                ` - ${
                  currentGroup.questions[currentGroup.questions.length - 1]
                    .number
                }`}
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <LinearProgress
                variant="determinate"
                color="secondary"
                value={Math.round(
                  ((currentGroupIndex + 1) / questionGroup.length) * 100
                )}
                sx={{ width: 150, height: 8, borderRadius: 4 }}
              />
              <Tooltip title="View all questions">
                <IconButton
                  color="primary"
                  onClick={handleOpenQuestionList}
                  size="small"
                  sx={{
                    border: "1px solid",
                    borderColor: "primary.main",
                    p: 0.5,
                  }}
                >
                  <ListAlt />
                </IconButton>
              </Tooltip>
            </Box>
          </>
        )}
      </Box>

      {/* Next Button */}

      <Button
        variant="contained"
        color="primary"
        size="large"
        onClick={handleNext}
        endIcon={<ArrowRightOutlined />}
        sx={{ px: 3, py: 1 }}
        disabled={nextDisabled}
      >
        Next
      </Button>
    </Box>
  );
}
